import React from 'react';
import { EmptyStateRow, TableLoader } from 'features/command-center/components';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS } from 'features/command-center/constants';
import { replaceQueryParams } from 'features/command-center/utils';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import { UIStatus } from 'UI/constants/status';

import { RecruiterExpandableRow } from './RecruiterExpandableRow';

export const YTDProductionByRecruiter = ({ columns, selectedTeam, queryParams }) => {
  const updatedQueryParams = replaceQueryParams({
    queryParams,
    keyParam: 'teams',
    valueParam: selectedTeam
  });
  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.productionYearToDateByRecruiter}?${updatedQueryParams}`;

  const { state } = useFetchWithStatusV2({
    endpoint,
    apiInstance: SECONDARY_API_CLIENT
  });
  const data = state?.results ?? [];

  if (state.status === UIStatus.Loading) return <TableLoader colSpan={columns.length} />;

  if (!data || data.length === 0) return <EmptyStateRow colSpan={columns.length} />;

  return data.map(row => <RecruiterExpandableRow key={row.empNo} columns={columns} row={row} />);
};
